interface Props {
  show: boolean;
  fill?: string;
}

const Spinner = (props: Props) => {
  const { show, fill = "#fff" } = props;

  if (!show) {
    return null;
  }

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      className="mx-2"
    >
      <rect
        className="spinner_9y7u"
        x="1"
        y="1"
        rx="1"
        width="10"
        height="10"
      />
      <rect
        className="spinner_9y7u spinner_DF2s"
        x="1"
        y="1"
        rx="1"
        width="10"
        height="10"
      />
      <rect
        className="spinner_9y7u spinner_q27e"
        x="1"
        y="1"
        rx="1"
        width="10"
        height="10"
      />
    </svg>
  );
};

export default Spinner;
